"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _fancyFooter = require("./fancyFooter");

var _fancyFooter2 = _interopRequireDefault(_fancyFooter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _fancyFooter2.default;